import { render } from "./DjiInBoundOrderView.vue?vue&type=template&id=c3f52f1a&scoped=true"
import script from "./DjiInBoundOrderView.vue?vue&type=script&lang=js"
export * from "./DjiInBoundOrderView.vue?vue&type=script&lang=js"

import "./DjiInBoundOrderView.vue?vue&type=style&index=0&id=c3f52f1a&scoped=true&lang=less"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3f52f1a"]])

export default __exports__